import { fansupportPublic } from "../index";

export const getAds = async ({ countryId, languageId, platformType, location }) => {
    return fansupportPublic.get('/media-content', {params: {
        countryId,
        languageId,
        platformType,
        location
    }})
}